import type { StateCreator } from 'zustand';

export interface ResourcesSlice {
	// Selected resource IDs (can change dynamically via resource fields)
	selectedResourceIds: number[];

	/**
	 * Resource mode determines how resources are matched for availability:
	 * - 'any': At least one of the selected resources must be available (automatic/flexible)
	 * - 'all': All selected resources must be available simultaneously (manual/strict)
	 *
	 * This comes from useResourceIds hook which returns 'any' for automatic resource
	 * selection and 'all' for manual/static resource selection.
	 */
	resourceMode: 'any' | 'all';

	// Actions
	setSelectedResourceIds: (resourceIds: number[]) => void;
	setResourceMode: (mode: 'any' | 'all') => void;
}

export const createResourcesSlice: StateCreator<ResourcesSlice> = (set) => ({
	selectedResourceIds: [],
	resourceMode: 'any',

	setSelectedResourceIds: (resourceIds) =>
		set({ selectedResourceIds: resourceIds }),
	setResourceMode: (mode) => set({ resourceMode: mode }),
});
